import { ActivityItemType, PromoB2BTableData } from 'entities/promo/types';
import { dateFormatted } from 'shared/helpers/dateFormatted';

export const useDefaultPromoB2BTableValues = (data: ActivityItemType[]): PromoB2BTableData[] =>
  data.map((activity) => ({
    id: activity.id,
    promoName: activity.name?.ru || 'Не указано',
    typePromo: activity.activity_type?.name || 'Не указано',
    registrationRange: `${dateFormatted(activity?.reg_start_date, true)} - ${dateFormatted(
      activity?.reg_end_date,
      true,
    )}`,
    activeRange: `${dateFormatted(activity?.activity_start_date, true)} - ${dateFormatted(
      activity?.activity_end_date,
      true,
    )}`,
    accessBonusRang: `${dateFormatted(activity?.bonus_start_date, true)} - ${dateFormatted(
      activity?.bonus_end_date,
      true,
    )}`,
  }));
